import { useEffect, useState } from "react";
import { Download, Share, Smartphone } from "lucide-react";
import { pwa } from "../pwa/sw-register";

export function InstallCard() {
  const [can, setCan] = useState(pwa.canInstall());
  const [installed, setInstalled] = useState(pwa.isStandalone());
  useEffect(() => pwa.onInstallable(() => setCan(true)), []);

  if (installed) {
    return <div className="fp-card text-sm text-slate-600" data-testid="install-status-installed"><Smartphone className="mb-2 text-[#036248]" size={20} />FASTPASS is installed on this device.</div>;
  }
  return (
    <div className="fp-card space-y-3" data-testid="install-card">
      <p className="font-display font-bold text-slate-900">Install FASTPASS on your phone</p>
      {can && (
        <button data-testid="install-app-button" className="fp-btn-primary w-full"
          onClick={async () => setInstalled(await pwa.promptInstall())}>
          <Download size={16} /> Install app
        </button>
      )}
      <ul className="space-y-2 text-sm text-slate-600">
        <li><strong>Android (Chrome):</strong> tap the ⋮ menu → <em>Install app</em> or <em>Add to Home screen</em>.</li>
        <li><strong>iPhone / iPad (Safari):</strong> tap <Share size={13} className="inline" /> Share → <em>Add to Home Screen</em>.</li>
      </ul>
    </div>
  );
}
